module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/fresa/climasense/cenicilla_fresa/curativa/vigold.png
// module id = 1548
// module chunks = 3